import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { addPageObject, addPageObjectOffline } from "../../../../store/actions/pages";
import withLayout from "../../common/layout";
import { AddButton, BoxDiv, CalendarBox, CalendarTable, Count, DashboardSection, DayCell, DropTarget, EmployeeCell, EmployeeCellTD, IconWrapper, SettingsBox, Tile, Title, TitleBox } from "./styles";
import { GetIcon } from "../../../../icons";
import { useTranslation } from "react-i18next";
import { convertMinutesToHHMM, formatDateToDayAndDate } from "../../../functions/dataFormat";
import { Container } from "../../common/layout/styels";
import moment from "moment";
import { generateThumbnail } from "../../../functions/string";
import { Filter1 } from "../../../elements/dateselector/styles";
import { NoData } from "../../../elements/list/styles";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { getData, postData } from "../../../../backend/api";
import Checkbox from "../../../elements/checkbox";
import PopupView from "../../../elements/popupview";
import { dateFormat } from "../../../functions/date";
import i18n from "i18next";
import { Link, useNavigate } from "react-router-dom";
import { DisplayInformations } from "../../../elements/list/popup";
import ReactApexChart from "react-apexcharts";
const Dashboard = (props) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const themeColors = useSelector((state) => state.themeColors);
  const [initialized, setInitialized] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);
  const [organisedData, setOrganisedData] = useState({});
  const [dashboardDefault, setDashboardDefault] = useState([]);
  const [leavesData, setLeavesData] = useState({});
  const [currentDate, setCurrentDate] = useState(moment());
  const dashboard = useSelector((state) =>
    state.pages[`dashboard`]
      ? state.pages[`dashboard`]
      : {
          data: null,
          isLoading: true,
          error: null,
        }
  );

  useEffect(() => {
    document.title = `${t("dashboard")} - PersoBase`;
  }, [t]);

  const user = useSelector((state) => state.login)
  const [selectedLanguage] = useState(i18n.language || "de");
  const dashboardOrder = useSelector((state) => (state.pages[`dashboardOrder`] ? state.pages[`dashboardOrder`] : []));
  // const [birthdays, setBirthday] = useState(dashboard?.data?.birthdays ?? []);
  // const [leaves, setLeaves] = useState(dashboard?.data?.leaves ?? []);
  const [state, setState] = useState(null);
  let date = new Date();
  useEffect(() => {
    // setBirthday(dashboard?.data?.birthdays ?? []);
    // setLeaves(dashboard?.data?.leaves ?? []);
    const data = {};
    if (dashboard?.data?.dashboard) {
      data["status"] = dashboard?.data?.status;
    }
    if (dashboard?.data?.hourlyStatistics) {
      data["hourlyStatistics"] = dashboard?.data?.hourlyStatistics;
    }
    if (dashboard?.data?.leaves) {
      data["leave"] = dashboard?.data?.leaves;
      setLeavesData(dashboard?.data?.leaves);
    }
    if (dashboard?.data?.birthdays) {
      data["birthdays"] = dashboard?.data?.birthdays;
    }
    if (dashboard?.data?.news) {
      data["news"] = dashboard?.data?.news;
    }
    if (dashboard?.data?.leaveRequest) {
      data["leaveRequest"] = dashboard?.data?.leaveRequest;
    }
    if (dashboard?.data?.sickLeave) {
      data["sickLeave"] = dashboard?.data?.sickLeave;
    }
    if (dashboard?.data?.companyPerCountry && dashboard?.data?.companyPerCountry.length > 0) {
      let series = [];
      let labels = [];
      dashboard?.data?.companyPerCountry.map((item) => {
        const natName = localStorage.getItem('_lang') 
            ? item[localStorage.getItem('_lang')] || item.de 
            : item.de;
        series.push(item.count);
        labels.push(natName);
      });
      setState({  
        series: series,
        options: {
          chart: {
            width: 380,
            type: 'pie',
          },
          labels: labels,
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        },
      
      
    })
    }
    setOrganisedData(data);
    setDashboardDefault(dashboard?.data?.dashboardDefault ?? []);
  }, [dashboard]);

  useEffect(() => {
    props.setLoaderBox(dashboard.isLoading);
    dashboard.isLoading && setInitialized(true);
  }, [dashboard, props]);

  useEffect(() => {
    if (initialized) {
      dispatch(addPageObject("dashboard", 0, {}));
    }
  }, [initialized, dispatch]);

  useEffect(() => {}, [dashboard]);
  const GetValue = (type, itemValue) => {
    switch (type) {
      case "minute":
        return convertMinutesToHHMM(parseFloat(itemValue ?? 0));
      default:
        return itemValue ?? 0;
    }
  };
  const ArrowAction = async (direction) => {
    const newDate = moment(currentDate).add(direction, "month");
    const data = await getData({ currentDate: newDate.toISOString() }, "dashboard/leaves", dispatch, navigate);
    setLeavesData(data.data);
    setCurrentDate(newDate);
  };
  const getMonthDays = () => {
    const startOfMonth = moment(currentDate).startOf("month");
    const endOfMonth = moment(currentDate).endOf("month");
    const daysInMonth = [];

    let currentDay = startOfMonth;

    while (currentDay.isSameOrBefore(endOfMonth, "day")) {
      daysInMonth.push(moment(currentDay));
      currentDay.add(1, "day");
    }

    return daysInMonth;
  };
  const DraggableDashboard = ({ data, className = "", index }) => {
    const [isDragging, setIsDragging] = useState(false);
    const [isdrop, setIsDrop] = useState(false);
    const [over, setOver] = useState(false);

    const [, drag] = useDrag({
      type: "ITEM",
      item: { index: index }, // Use 'item' to specify the data being dragged
      collect: (monitor) => {
        setIsDragging(monitor.isDragging());
        return {};
      },
    });

    return (
      <>
        {/* <div> </div> */}
        <BoxDiv style={{position:'relative',borderRadius:'10px',border:'2px solid #d6e0ff'}}>
          <div style={{position:'absolute',left:0,right:0,top:0,bottom:0,zIndex: isdrop?10:-1}}>{DropHere(index,setIsDrop,setOver)}</div>

          <BoxDiv style={{visibility: over? 'hidden':'visible', opacity: isDragging ? 0.5 : 1, border:'none',height:'calc(100% - 20px)'}} ref={drag} className="plain">
            <CalendarBox >{data}</CalendarBox>
          </BoxDiv>
        </BoxDiv>
      </>
    );
  };
  const DropHere = (index = 0,setIsDrop,setOver) => {
    const [{ isOver, canDrop }, drop] = useDrop({
      accept: "ITEM",
      hover: (draggedItem) => {
        const draggedIndex = draggedItem.index;
        if (draggedIndex !== index) {
          console.log("no");
        }
      },
      drop: (draggedItem) => {
        // Logic to handle drop event
        console.log(index, draggedItem.index);
        const draggedIndex = draggedItem.index;
        if (draggedIndex !== index) {
          // Swap the dashboards
          const updatedDashboards = [...dashboardOrder];
          // const temp = updatedDashboards[index];
          // updatedDashboards[index] = updatedDashboards[draggedIndex];
          // updatedDashboards[draggedIndex] = temp;
          const draggedItem = updatedDashboards.splice(draggedIndex, 1)[0];

          // Insert the dragged item at the new position
          updatedDashboards.splice(index, 0, draggedItem);
          postData({ dashboardOrder: updatedDashboards }, "admin/update-dashboard", dispatch, navigate);
          dispatch(addPageObjectOffline("dashboardOrder", updatedDashboards ?? []));
          // Update the dashboard state
        }
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    });

    useEffect(() => {
      setIsDrop(canDrop);
      setOver(isOver)
    }, [canDrop,isOver])

    
    

    return (
      (
        <DropTarget
          ref={drop}
          style={{
            backgroundColor: isOver? "white" : "transparent",
            minHeight: "172px",
            border: isOver? "1px dashed #aaa;" : "none",
          }}
        >
          {isOver ? <span>{t("Move here")}</span> : null}
        </DropTarget>
      )
    );
  };

  const generateView = ({ type, data, index }) => {
    switch (type) {
      case "leave":
        return (
          <DraggableDashboard
            key={"item" + index}
            index={index}
            data={
              <>
                <div className="head" style={{borderBottom: '2px solid #d6e0ff'}}>
                  <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
                    <GetIcon icon={"leaveType"} />
                    {t("dash-" + type)}
                  </div>
                </div>
                <BoxDiv>
                  <CalendarTable>
                    {/* <thead>
                      <tr>
                        <EmployeeCell>
                          <Filter1 className="dashboard" theme={props.themeColors}>
                            <div onClick={() => ArrowAction(-1)}>
                              <GetIcon icon={"previous"}></GetIcon>
                            </div>
                            <span> {currentDate && currentDate.format("MMMM Y")}</span>
                            <div onClick={() => ArrowAction(1)}>
                              <GetIcon icon={"next"}></GetIcon>
                            </div>
                          </Filter1>
                        </EmployeeCell>
                        {getMonthDays().map((day) => (
                          <DayCell active={day.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")} key={day}>{`${day.format("DD")}`}</DayCell>
                        ))}
                      </tr>
                    </thead> */}
                    <tbody>
                      {leavesData?.length > 0 &&
                        leavesData?.map((employee) => (
                          <tr key={`${employee.firstName}-${employee.lastName}`}>
                            <EmployeeCell className="align">
                              {generateThumbnail(`${employee.firstName} ${employee.lastName}`, true, employee.photo)}
                              {`${employee.firstName} ${employee.lastName}`}
                            </EmployeeCell>
                            <EmployeeCellTD>{`${employee.leaves?.sort((a, b) => new Date(a.leaveDate) - new Date(b.leaveDate))[0]?.leaveType[selectedLanguage]}`}</EmployeeCellTD>
                            <DayCell className="right" key={`${employee.firstName}`}>{`${moment(employee.leaves?.sort((a, b) => new Date(a.leaveDate) - new Date(b.leaveDate))[0].leaveDate).format("DD.MM.YYYY")} - ${moment(employee.leaves?.sort((a, b) => new Date(a.leaveDate) - new Date(b.leaveDate))[employee.leaves?.length-1].leaveDate).format("DD.MM.YYYY")}`}</DayCell>
                            {/* {getMonthDays().map((day) => {
                              const getFind = employee.leaves?.some((item) => day.format("YYYY-MM-DD") === moment(item.leaveDate).format("YYYY-MM-DD"));
                              return (
                                <DayCell key={`${employee.firstName}-${day.format("DD")}`}>
                                  {getFind && (
                                    <span className="leave" style={{ color: "red" }}>
                                      <GetIcon icon="leaveType" />
                                    </span>
                                  )}
                                </DayCell>
                              );
                            })} */}
                          </tr>
                        ))}
                    </tbody>
                    {leavesData?.length === 0 && <NoData className="cover">{t("NoLeaves")}</NoData>}
                  </CalendarTable>
                </BoxDiv>
              </>
            }
          />
        );
      case "status":
      case "hourlyStatistics":
        return (
          <DraggableDashboard
            key={"item" + index}
            index={index}
            className="two"
            data={
              dashboard?.data?.[type].length > 0 ? (
                <BoxDiv className="radious" style={{border:'none'}}>
                  <div className="head" style={{borderBottom: '2px solid #d6e0ff'}}>
                  <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
                    <GetIcon icon={type} />
                    {t("dash-" + type)}
                  </div>
                  </div>
                  <BoxDiv className="two plain">
                    {dashboard?.data?.[type].map((item, index) =>
                      item.icon === "leaveType" ? (
                        <Tile key={`dashboard-${index}`}>
                          <TitleBox>
                            <Count>
                              {item.data.map((count) => (
                                <span className={count.status} key={count.status}>
                                  <GetIcon icon={count.status} />
                                  {GetValue(item.type, count.count ?? 0)}
                                </span>
                              ))}
                            </Count>
                            <Title>{t(item.title)}</Title>
                          </TitleBox>
                        </Tile>
                      ) : (
                        <Tile key={index}>
                          <TitleBox>
                            <Count>{GetValue(item.type, item.count ?? 0)}</Count>
                            <Title>{t(item.title)}</Title>
                          </TitleBox>
                          <IconWrapper style={{ background: item.background, color: item.color }}>
                            <GetIcon icon={item.icon} />
                          </IconWrapper>
                        </Tile>
                      )
                    )}
                  </BoxDiv>
                </BoxDiv>
              ) : null
            }
          />
        );
      case "birthdays":
        return (
          data && (
            <DraggableDashboard
              key={"item" + index}
              index={index}
              data={
                <>
                  <div className="head" style={{borderBottom: '2px solid #d6e0ff'}}>
                  <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
                    <GetIcon icon={"birthday"} />
                    {t("dash-" + type)}
                  </div>
                  </div>
                  <BoxDiv>
                    <CalendarTable>
                      <tbody>
                        {data.length > 0 &&
                          data.map(
                            (employee) =>
                              employee && (
                                <tr key={`birthday-${employee.firstName} ${employee.lastName}`}>
                                  <EmployeeCellTD className="align">
                                    {generateThumbnail(`${employee.firstName} ${employee.lastName}`, true, employee.photo)}
                                    {`${employee.firstName} ${employee.lastName}`}
                                  </EmployeeCellTD>
                                  <EmployeeCellTD>{employee?.departmentTitle}</EmployeeCellTD>
                                  <DayCell key={`${employee.firstName}`}>{moment(employee.birthDate).format("DD MMM")}</DayCell>
                                </tr>
                              )
                          )}
                      </tbody>
                    </CalendarTable>
                    {data.length === 0 && (
                      <BoxDiv>
                        <NoData className="cover">{t("noBirthdays")}</NoData>
                      </BoxDiv>
                    )}
                  </BoxDiv>
                </>
              }
            />
          )
        );
      case "leaveRequest":
        return (
          data && (
            <DraggableDashboard
              key={"item" + index}
              index={index}
              data={
                <>
                  <div className="head" style={{borderBottom: '2px solid #d6e0ff'}}>
                  <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
                    <GetIcon icon={"leaveRequest"} />
                    {t("dash-" + type)}
                  </div>
                  <Link style={{fontSize:'14px',textDecoration:'none',display:'flex',alignItems:'center',gap:'2px', color:'#3FC4FD'}} to={`/leave-request`} >
                      {t("View all")} 
                      <div style={{rotate:"-90deg"}}>
                        <GetIcon
                          fontSize="14px !important"
                          icon={"down"}
                        ></GetIcon>
                        </div>
                      </Link>
                  </div>
                  <BoxDiv>
                    <CalendarTable>
                      {/* <thead>
                        <tr>
                          <EmployeeCell className="nonstick">{t("employee")}</EmployeeCell>
                          <EmployeeCell>{t("leaveType")}</EmployeeCell>
                          <EmployeeCell className="title">{`${t("date")}`}</EmployeeCell>
                        </tr>
                      </thead> */}
                      <tbody>
                        {data.length > 0 &&
                          data.map(
                            (leave) =>
                              leave && (
                                <tr key={`request-${leave.user.firstName} ${leave.user.lastName}`}>
                                  <EmployeeCellTD className="nonstick align">
                                    {generateThumbnail(`${leave.user.firstName} ${leave.user.lastName}`, true, leave.user.photo)}
                                    {`${leave.user.firstName} ${leave.user.lastName}`}
                                  </EmployeeCellTD>
                                  <EmployeeCellTD>{`${leave.leaveType[selectedLanguage]}`}</EmployeeCellTD>
                                  <DayCell className="right" key={`${leave.user.firstName}`}>{`${moment(leave.startDate).format("DD.MM.YYYY")} - ${moment(leave.endDate).format("DD.MM.YYYY")}`}</DayCell>
                                </tr>
                              )
                          )}
                      </tbody>
                    </CalendarTable>
                    {data.length === 0 && (
                      <BoxDiv>
                        <NoData className="cover">{t("noLeaveRequest")}</NoData>{" "}
                      </BoxDiv>
                    )}
                  </BoxDiv>
                </>
              }
            />
          )
        );
      case "news":
        return (
          data && (
            <DraggableDashboard
              key={"item" + index}
              index={index}
              data={
                  <>
                    <div className="head" style={{borderBottom: '2px solid #d6e0ff'}}>
                      <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
                        <GetIcon icon={"news"} />
                        {t("dash-" + type)}
                      </div>
                      <Link style={{fontSize:'14px',textDecoration:'none',display:'flex',alignItems:'center',gap:'2px', color: '#3FC4FD'}} to={`/${type}`} >
                      {t("View all")} 
                      <div style={{rotate:"-90deg"}}>
                        <GetIcon
                          fontSize="14px !important"
                          icon={"down"}
                        ></GetIcon>
                        </div>
                      </Link>
                    </div>
                    {data.length > 0 ? <BoxDiv>
                      <CalendarTable style={{overflow:"hidden"}}>
                        <thead>
                          <tr>
                            <EmployeeCell className="thead" >{t("message")}</EmployeeCell>
                            <EmployeeCell className="thead">{`${t("createdAt")}`}</EmployeeCell>
                            <EmployeeCell className="thead">{t("addedBy")}</EmployeeCell>
                            <EmployeeCell className="thead">{t("status")}</EmployeeCell>
                            <EmployeeCell className="thead" ></EmployeeCell>
                          </tr>
                        </thead>
                        <tbody>
                          {data.length > 0 &&
                            data.map(
                              (leave) =>
                                leave && (
                                  <tr key={`news-${leave.addedBy.firstName} ${leave.addedBy.lastName}`}>
                                    <DayCell className="left">{leave?.news?.length > 15 ? (leave?.news?.slice(0,15) + "...") : leave?.news}</DayCell>
                                    <DayCell className="left">{dateFormat(leave.createdAt)}</DayCell>
                                    <DayCell className="left">{`${leave.addedBy.firstName} ${leave.addedBy.lastName}`}</DayCell>
                                    <DayCell className="left">{t(leave.status)}</DayCell>
                                    <DayCell onClick={()=> handleOpenNews(leave)} style={{rotate:"-90deg",cursor:"pointer"}}><GetIcon icon={"down"} /></DayCell>
                                    
                                  </tr>
                                )
                            )}
                        </tbody>
                      </CalendarTable>
                    </BoxDiv> : <BoxDiv>
                    <NoData className="cover">{t("noNews")}</NoData>
                  </BoxDiv>}
                  </>
              }
            />
          )
        );
      case "sickLeave":
        return (
          data && (
            <DraggableDashboard
              key={"item" + index}
              index={index}
              data={
                <>
                  <div className="head" style={{borderBottom: '2px solid #d6e0ff'}}>
                  <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
                    <GetIcon icon={"leaveType"} />
                    {t("dash-" + type)}
                  </div>
                  {/* <Link style={{fontSize:'14px',textDecoration:'none',display:'flex',alignItems:'center',gap:'2px'}} to={`/report`} >
                      {t("View all")} 
                      <div style={{rotate:"-90deg"}}>
                        <GetIcon
                          fontSize="14px !important"
                          icon={"down"}
                        ></GetIcon>
                        </div>
                      </Link> */}
                  </div>
                  <BoxDiv>
                    <CalendarTable>
                      {/* <thead>
                        <tr>
                          <EmployeeCell>{t("employee")}</EmployeeCell>
                          <EmployeeCell>{t("leaveType")}</EmployeeCell>
                        </tr>
                      </thead> */}
                      <tbody>
                        {data.length > 0 &&
                          data.map(
                            (leave) =>
                              leave && (
                                
                                <tr key={`${leave.user.firstName} ${leave.user.lastName}`}>
                                  
                                  <EmployeeCellTD className="align">
                                    {generateThumbnail(`${leave.user.firstName} ${leave.user.lastName}`, true, leave.user.photo)}
                                    {`${leave.user.firstName} ${leave.user.lastName}`}
                                  </EmployeeCellTD>
                                  <EmployeeCellTD>{`${leave.leaveType[selectedLanguage]}`}</EmployeeCellTD>
                                  <EmployeeCellTD>{t("Whole day")}</EmployeeCellTD>
                                  
                                </tr>
                              )
                          )}
                      </tbody>
                    </CalendarTable>
                    {data.length === 0 && (
                      <BoxDiv>
                        <NoData className="cover">{t("noSickLeave")}</NoData>{" "}
                      </BoxDiv>
                    )}
                  </BoxDiv>
                </>
              }
            />
          )
        );
      default:
        return (
          <DraggableDashboard
            key={"item" + index}
            index={index}
            data={
              <BoxDiv>
                <NoData className="cover">{t("notFound", { page: t(type) })}</NoData>
              </BoxDiv>
            }
          />
        );
    }
  };
  const addDashboard = (title) => {
    let updatedDashboards = [...dashboardOrder];

    // Check if the title is already in the dashboardOrder
    const index = updatedDashboards.findIndex((item) => item === title);

    if (index === -1) {
      // If not in the array, add it
      updatedDashboards.push(title);
    } else {
      // If already in the array, remove it
      updatedDashboards = updatedDashboards.filter((item, i) => i !== index);
    }

    // Assuming postData and setDashboardOrder are defined elsewhere in your code
    postData({ dashboardOrder: updatedDashboards }, "admin/update-dashboard", dispatch, navigate);

    dispatch(addPageObjectOffline("dashboardOrder", updatedDashboards ?? []));
  };

  const [openData, setOpenData] = useState(null);
  const [isOpenPop, setIsOpenPop] = useState(false);
  const [attributes, setAttributes] = useState([]);
  const [openDataTitle, setOpenDataTitle] = useState("");

  const handleOpenNews = (news) => {
    console.log(news);
    setOpenDataTitle(news.title);
    setOpenData(news);
    setAttributes([
      {
        type: "date",
        placeholder: "createdAt",
        name: "createdAt",
        validation: "",
        default: "",
        label: "createdAt",
        required: true,
        view: true,
        add: false,
        update: false,
      },
      {
        type: "select",
        placeholder: "addedBy",
        name: "addedBy",
        validation: "addedBy",
        showItem: "fullName",
        collection: "addedBy",
        filter: false,
        default: "",
        label: "addedBy",
        required: true,
        view: true,
        add: false,
        update: false,
      },
      {
        type: "text",
        placeholder: "subject",
        name: "title",
        validation: "",
        default: "",
        label: "subject",
        required: true,
        view: true,
        add: false,
        update: false,
      },
      {
        type: "textarea",
        placeholder: "message",
        name: "news",
        validation: "",
        default: "",
        label: "message",
        required: true,
        view: true,
        add: false,
        update: false,
      },
      {
        type: "select",
        placeholder: "status",
        name: "status",
        validation: "",
        default: "",
        showItem: "translate",
        label: "status",
        required: true,
        view: true,
        filter: false,
        tag: true,
        add: false,
        update: false,
        apiType: "JSON",
        selectApi: [
          { id: "Draft", value: t("Draft") },
          { id: "Published", value: t("Published") },
          { id: "Archive", value: t("Archive") },
        ],
      },
      {
        type: "select",
        placeholder: "sharedTo",
        name: "sharedTo",
        validation: "",
        default: "",
        label: "sharedTo",
        showItem: "translate",
        required: true,
        view: true,
        filter: false,
        tag: true,
        add: false,
        update: false,
        apiType: "JSON",
        selectApi: [
          { id: "Employees", value: t("Employees") },
          { id: "Department", value: t("Department") },
          { id: "All", value: t("All") },
        ],
      },
      // {
      //   type: "multiSelect",
      //   placeholder: "department",
      //   condition: { item: "sharedTo", if: "Department", else: "disabled", then: "enabled" },
      //   name: "department",
      //   validation: "",
      //   showItem: "title",
      //   default: "",
      //   label: "department",
      //   required: true,
      //   filterType: "multiSelect",
      //   view: false,
      //   tag: true,
      //   add: false,
      //   update: false,
      //   apiType: "API",
      //   selectApi: "department/select",
      // },
      // {
      //   type: "multiSelect",
      //   placeholder: "employee",
      //   condition: { item: "sharedTo", if: "Employees", else: "disabled", then: "enabled" },
      //   name: "user",
      //   validation: "",
      //   showItem: "fullName",
      //   default: "",
      //   label: "employee",
      //   required: true,
      //   filterType: "multiSelect",
      //   view: false,
      //   tag: true,
      //   add: false,
      //   update: false,
      //   apiType: "API",
      //   selectApi: "user/select",
      // },
      {
        type: "checkbox",
        placeholder: "readReceipt",
        name: "readReceipt",
        validation: "",
        showItem: "",
        default: "",
        label: "readReceipt",
        required: true,
        view: false,
        tag: true,
        add: false,
        update: false,
      },
    ])
    setIsOpenPop(true);
  }


  return (
    <Container className="noshadow column">
      {openSettings && (
        <PopupView
          themeColors={themeColors}
          openData={{ data: { settings: "dashboardSettings" } }}
          itemTitle={{ name: "settings", collection: "" }}
          popupData={
            <SettingsBox>
              {dashboardDefault.map((item) => {
                const has = dashboardOrder.some((order) => order === item);
                return (
                  // <Button onClick={() => addDashboard(item)}>{t(item)}</Button>
                  <Checkbox label={t("dash-" + item)} checked={has} onChange={() => addDashboard(item)} />
                );
              })}
            </SettingsBox>
          }
          customClass={"small"}
          closeModal={() => {
            setOpenSettings(false);
          }}
        ></PopupView>
      )}

      <DndProvider backend={HTML5Backend}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center',padding:"10px 0 30px 0"}}>
          <div style={{backgroundColor:'transparent', color:'#0C3090'}} className="plain">
            <div style={{fontWeight:'bold'}}>{t(formatDateToDayAndDate(date).dayName)}, {formatDateToDayAndDate(date).fullDate}</div>
            <div style={{fontSize:'30px',fontWeight:'bold',marginTop:'10px'}}>{t("Hello")} {user?.data?.user?.fullName?.split(' ')[0]},</div>
          </div>
          <AddButton onClick={() => setOpenSettings((prev) => !prev)}>
            <GetIcon icon={"editDashboard"}></GetIcon> {t("edit")}
          </AddButton>
        </div>
        {/* {dashboardOrder?.length > 0 && ( */}
          <DashboardSection count={((dashboardOrder?.length) / 2).toFixed(0)} className="two">
            {/* <div className="">*/}
            {state && <BoxDiv className="radious" style={{border:'2px solid #d6e0ff'}}>
                  <div className="head">
                  <div style={{display:'flex',gap:'10px',alignItems:'center', fontWeight:'bold', color:'#0C3090'}}>
                    <GetIcon icon={"dashboard"} />
                    {t("dash-" + "companyPerCountry")}
                  </div>
                  </div> 
                  <div>
            <div id="chart">
                <ReactApexChart options={state.options} series={state.series} type="pie" width={380} />
              </div>
            <div id="html-dist"></div>
          </div>
                </BoxDiv>}
                {/* </div> */}
                
            {dashboardOrder.map((page, index) => generateView({ data: organisedData[page] ?? [], type: page, index }))}
          </DashboardSection>
        {/* )} */}
      </DndProvider>
      
      {isOpenPop && (
        <PopupView
          // Popup data is a JSX element which is binding to the Popup Data Area like HOC
          popupData={<DisplayInformations udpateView={false} isEditingHandler={false} actions={null} setMessage={null} setLoaderBox={null} formMode={"normal"} formView={"normal"} attributes={attributes} data={openData} api={"api"} tabName={openDataTitle} />}
          // themeColors={themeColors}
          closeModal={() => {
            setIsOpenPop(false);
          }}
          setMessage={null}
          setLoaderBox={null}
          profileImage={null}
          itemTitle={openDataTitle}
          openData={{data:openData}} // Pass selected item data to the popup for setting the time and taking menu id and other required data from the list item
          customClass={"normal"}
        ></PopupView>
      )}
    </Container>
  );
};

export default withLayout(Dashboard);
